// extracted by mini-css-extract-plugin
export default {"details_coverage":"S5_DetailsCoverage_details_coverage__rMslN","iframeMapId":"S5_DetailsCoverage_iframeMapId__cKq44"};